import React, { useEffect } from "react";
import { useAppSelector } from "../core/feature/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import refunded from "../assets/images/icon_checkout/refunded.svg";
import { ConfigColor } from "../config/global";

const eye = <FontAwesomeIcon icon={faEye} />;
const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />;

const Refunded = () => {
  const color = ConfigColor();
  const company: any = useAppSelector((state) => state.company.company);
  const customSuccesUrl = JSON.parse(
    localStorage.getItem("customSuccessUrl") as any
  );

  const goToBack = () => {
    if (customSuccesUrl) {
      window.location.href = `https://${customSuccesUrl}`;
    } else {
      window.location.href = `${company?.successRedirectUrl}`;
    }
    localStorage.removeItem("customSuccessUrl");
    localStorage.removeItem("customBackUrl");
    localStorage.removeItem("customBaseUrl");
  };

  const title = "Pembayaran";
  document.title = title;

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, [customSuccesUrl]);
  return (
    <>
      <div className="w-full md:w-3/4 2xl:2/5 h-full mx-auto">
        <div className="space-y-8">
          <div className="mt-24">
            <img
              src={refunded}
              alt=""
              className="mx-auto w-[100%] md:w-[50%] lg:w-[50%] xl:w-[40%] 2xl:w-[40%]"
            />
          </div>
          <div className="md:text-xl 2xl:text-2xl text-center space-y-4">
            <div className="mx-auto">Dana Dikembalikan</div>
            <div className="text-sm md:text-lg 2xl:text-xl text-[#263339]">
              Terjadi sesuatu pada pembayaran Anda,
              <br /> dana akan dikembalikan ke saldo utama
              <br /> user.
            </div>
          </div>
          <div className="flex justify-center px-4">
            <button
              className="w-full text-white p-2 rounded md:w-[30%]"
              onClick={goToBack}
              style={{ backgroundColor: color.color1 }}
            >
              Kembali
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Refunded;
